import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import it from '../locales/it.json'
import en from '../locales/en.json'

// Read persisted language from Zustand's localStorage key
function getSavedLang() {
  try {
    const raw = localStorage.getItem('organizer-i18n')
    return JSON.parse(raw)?.state?.lang || 'it'
  } catch {
    return 'it'
  }
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      it: { translation: it },
      en: { translation: en }
    },
    lng: getSavedLang(),
    fallbackLng: 'it',
    interpolation: {
      escapeValue: false // React already escapes values
    }
  })

export default i18n
